import { TransportDirection } from "@sinch/core/entities/serverEnums";
import { TransportDirection as TransportDirectionType } from "@sinch/core/entities/serverEnums.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

/**
 * Single source of truth for how a transport direction looks in the app: label.
 *
 * Use these getters wherever a transport direction is shown.
 * Never hardcode its label in a component, change them here.
 * Every value is shown in the "Entity Identity/TransportDirection" story.
 */
export const useTransportDirection = () => {
  const { t } = useTranslation();

  const positionRoles = {
    [TransportDirection.There]: {
      label: t("Transport.there"),
    },
    [TransportDirection.Back]: {
      label: t("Transport.back"),
    },
  } as Record<TransportDirectionType, { label: string }>;
  const getProp = useEntityProps(positionRoles);

  const getTransportDirectionLabel = getProp<string>("label");
  const getSortedDirections = () => Object.keys(positionRoles) as TransportDirectionType[];

  return { getTransportDirectionLabel, getSortedDirections };
};
